webpackJsonp([60070788768415],{

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolTipBottom = function (_React$Component) {
	  _inherits(ToolTipBottom, _React$Component);
	
	  function ToolTipBottom() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ToolTipBottom);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      opacity: 0
	    }, _this.getElementY = function (query) {
	      return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top;
	    }, _this.doScrolling = function (element, duration) {
	      var startingY = window.pageYOffset;
	      var elementY = _this.getElementY(element);
	      // If element is close to page's bottom then window will scroll only to some position above the element.
	      var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY;
	      var diff = targetY - startingY;
	      // Easing function: easeInOutCubic From: https://gist.github.com/gre/1650294
	      var easing = function easing(t) {
	        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	      };
	      var start = void 0;
	      if (!diff) return;
	      // Bootstrap our animation - it will get called right before next frame shall be rendered.
	      window.requestAnimationFrame(function step(timestamp) {
	        if (!start) start = timestamp;
	        // Elapsed miliseconds since start of scrolling.
	        var time = timestamp - start;
	        // Get percent of completion in range [0, 1].
	        var percent = Math.min(time / duration, 1);
	        // Apply the easing.
	        // It can cause bad-looking slow frames in browser performance tool, so be careful.
	        percent = easing(percent);
	        window.scrollTo(0, startingY + diff * percent);
	        // Proceed with animation as long as we wanted it to.
	        if (time < duration) {
	          window.requestAnimationFrame(step);
	        }
	      });
	    }, _this.setTimer = function () {
	      setTimeout(function () {
	        return _this.setState({
	          opacity: 1
	        });
	      }, 1500);
	    }, _this.componentDidMount = function () {
	      _this.setTimer();
	    }, _this.render = function () {
	      var styles = {
	        position: "absolute",
	        bottom: "2rem",
	        left: "50%",
	        transform: "translateX(-50%)",
	        color: "yellow",
	        zIndex: "99",
	        opacity: _this.state.opacity,
	        transition: "0.5s ease-in"
	      };
	      return _react2.default.createElement(
	        "div",
	        { style: styles },
	        _this.props.children,
	        _react2.default.createElement(
	          "div",
	          { onClick: function onClick() {
	              _this.doScrolling("#" + _this.props.anchorId, _this.props.scrollSpeed);
	            }, className: "mouse" },
	          _react2.default.createElement("div", { className: "scrollbutton" })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return ToolTipBottom;
	}(_react2.default.Component);
	
	exports.default = ToolTipBottom;
	module.exports = exports["default"];

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SEO = __webpack_require__(54);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _SiteConfig = __webpack_require__(12);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Starter = __webpack_require__(55);
	
	var _Starter2 = _interopRequireDefault(_Starter);
	
	var _ToolTipBottom = __webpack_require__(39);
	
	var _ToolTipBottom2 = _interopRequireDefault(_ToolTipBottom);
	
	var _PostListing = __webpack_require__(53);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _FadeInWrapper = __webpack_require__(7);
	
	var _FadeInWrapper2 = _interopRequireDefault(_FadeInWrapper);
	
	var _GriegMFM = __webpack_require__(71);
	
	var _GriegMFM2 = _interopRequireDefault(_GriegMFM);
	
	var _GriegMinuttForMinutt = __webpack_require__(51);
	
	var _GriegMinuttForMinutt2 = _interopRequireDefault(_GriegMinuttForMinutt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OpusForOpus = function (_React$Component) {
	  _inherits(OpusForOpus, _React$Component);
	
	  function OpusForOpus() {
	    _classCallCheck(this, OpusForOpus);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  OpusForOpus.prototype.render = function render() {
	    var postEdges = this.props.data.allMarkdownRemark.edges;
	    return _react2.default.createElement(
	      "div",
	      { style: { height: "100%" } },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Opus for opus | Edvard Grieg" }),
	      _react2.default.createElement(_SEO2.default, { postEdges: postEdges, pageImg: _GriegMinuttForMinutt2.default }),
	      _react2.default.createElement(
	        _Starter2.default,
	        { height: "1" },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "EDVARD GRIEG"
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "OPUS FOR OPUS"
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Les om hvert eneste verk, og se hvilken artist som spiller hvert opus under Grieg minutt for minutt. Skroll ned for \xE5 begynne."
	        )
	      ),
	      _react2.default.createElement(_ToolTipBottom2.default, { anchorId: "treeView", scrollSpeed: 1000 }),
	      _react2.default.createElement(_PostListing2.default, { postEdges: postEdges, view: "treeView", title: "Opus by Opus", img: _GriegMFM2.default })
	    );
	  };
	
	  return OpusForOpus;
	}(_react2.default.Component);
	
	exports.default = OpusForOpus;
	
	/* eslint no-undef: "off"*/
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GriegMinuttForMinutt.99794b9b.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-opus-for-opus-jsx-5bd756c59185e97b6faa.js